"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderEditorView = void 0;
var _react = require("react");
var _useTeacherApi = require("../hooks/useTeacherApi");
var _studyYear = require("../../../utilities/studyYear");
var _EnvironmentManager = require("../EnvironmentManager.provider");
var _main = require("../../../main");
var _AudiencePickerView = require("./AudiencePickerView");
var _TeacherSelection = require("./components/TeacherSelection");
var _EnvironmentSelection = require("./components/EnvironmentSelection");
var _RangeDateSelection = require("./components/RangeDateSelection");
var _EnvironmentManager2 = _interopRequireDefault(require("../EnvironmentManager.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SliderEditorView = props => {
  const styles = (0, _EnvironmentManager2.default)();
  const {
    mode,
    productInfo,
    environmentTitleMaxLength,
    enableRangeDateSelection,
    isLearingSite,
    onClose
  } = props;
  const {
    sourceEnvironmentId
  } = mode !== 'create' ? props : {};
  const isInCreationMode = ['create', 'duplicate'].includes(mode);
  const {
    userSessionData,
    schoolYear,
    defaultEnvironmentTeachers,
    srcEnvironmentId,
    userEnvironments,
    environmentData,
    getLabel,
    setPreloaderMode,
    setSliderView,
    setSchoolYear,
    setUserEnvironments,
    setEnvironmentIds,
    setEnvironmentSchoolId,
    setEnvironmentTitle,
    setEnvironmentProductInfo,
    setEnvironmentDates,
    setEnvironmentTeachers,
    setEnvironmentAudience,
    setIsReadOnlyEnvironment,
    setSrcEnvironmentId
  } = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext);
  const {
    initTeacherData,
    saveEnviroment,
    updateEnviroment
  } = (0, _useTeacherApi.useTeacherApi)(isLearingSite);
  const [isSaveDisabled, setIsSaveDisabled] = (0, _react.useState)(true);
  const [isDuplicatedEnvTitle, setIsDuplicatedEnvTitle] = (0, _react.useState)(false);
  const [isSaveErrorVisible, setIsSaveErrorVisible] = (0, _react.useState)(false);
  const onBack = () => {
    if (userSessionData.role === 'admin') {
      setSliderView('schoolSelector');
    } else {
      onClose();
    }
  };
  const onSave = environmentData => {
    setIsSaveErrorVisible(false);
    if (mode === 'create' || mode === 'duplicate') {
      setPreloaderMode('over');
      saveEnviroment(environmentData,
      // On "saveEnviroment" success
      (enviromentId, enviromentAudienceId) => {
        const savedEnvironmentIds = {
          Id: enviromentId,
          AudienceID: enviromentAudienceId
        };
        const savedEnvironmentData = {
          ...environmentData,
          Ids: savedEnvironmentIds
        };
        setEnvironmentIds(savedEnvironmentIds);
        setPreloaderMode(undefined);
        props?.onSave?.(savedEnvironmentData);
        setSliderView('environmentSaved');
        setTimeout(() => {
          setUserEnvironments(userEnvironments ? [...userEnvironments, savedEnvironmentData] : [savedEnvironmentData]);
        }, 500);
      },
      // On "saveEnviroment" error
      error => {
        setPreloaderMode(undefined);
        setIsSaveDisabled(false);
        setIsSaveErrorVisible(true);
        console.error(error);
      });
    } else if (mode === 'update') {
      setPreloaderMode('over');
      updateEnviroment(environmentData,
      // On "updateEnviroment" success
      () => {
        setPreloaderMode(undefined);
        props?.onSave?.(environmentData);
        setSliderView('environmentSaved');
        setTimeout(() => {
          setUserEnvironments(userEnvironments ? [...userEnvironments.filter(e => e.Ids.Id !== environmentData.Ids.Id), environmentData] : [environmentData]);
        }, 500);
      },
      // On "updateEnviroment" error
      error => {
        setPreloaderMode(undefined);
        setIsSaveDisabled(false);
        setIsSaveErrorVisible(true);
        console.error(error);
      });
    }
  };
  const onSourceEnvironmentChange = sourceEnv => {
    if (sourceEnv) {
      setSrcEnvironmentId(sourceEnv.Ids.Id);
      setEnvironmentProductInfo(sourceEnv.ProductInfo);
      setEnvironmentTeachers(sourceEnv.Teachers);
      setEnvironmentAudience(sourceEnv.Audience);
      if (mode === 'update') {
        setEnvironmentIds(sourceEnv.Ids);
        setEnvironmentTitle(sourceEnv.Title);
        setEnvironmentDates(sourceEnv.Dates);
        setIsReadOnlyEnvironment(sourceEnv.IsArchive);
      } else if (mode === 'duplicate') {
        setEnvironmentIds({
          Id: '',
          AudienceID: ''
        });
        setEnvironmentTitle('');
        setEnvironmentDates({
          Start: new Date(Math.max(...[new Date(), sourceEnv.Dates.Start ? new Date(sourceEnv.Dates.Start) : new Date(), schoolYear?.startDate ? new Date(schoolYear.startDate) : new Date()].map(date => date.getTime()))),
          End: new Date(Math.min(...[sourceEnv.Dates.End ? new Date(sourceEnv.Dates.End) : new Date(), schoolYear?.endDate ? new Date(schoolYear.endDate) : new Date()].map(date => date.getTime())))
        });
        setIsReadOnlyEnvironment(false);
      }
    } else {
      setSrcEnvironmentId(undefined);
    }
  };
  (0, _react.useEffect)(() => {
    const schoolId = userSessionData.role === 'admin' ? environmentData.SchoolID : userSessionData.schoolId ?? '';
    if (schoolId) {
      setEnvironmentSchoolId(schoolId);
      initTeacherData(productInfo.ProductId, schoolId, mode !== 'create');
      const studyYearData = (0, _studyYear.getStudyYearDataByDate)(new Date());
      setSchoolYear({
        startDate: studyYearData.start,
        endDate: studyYearData.end
      });
    }
  }, [mode, productInfo.ProductId, userSessionData.role, userSessionData.schoolId, environmentData.SchoolID, initTeacherData, setEnvironmentSchoolId, setSchoolYear]);
  (0, _react.useEffect)(() => {
    setEnvironmentProductInfo(productInfo);
    if (mode === 'create' && schoolYear?.endDate) {
      setEnvironmentDates({
        Start: new Date(),
        End: new Date(schoolYear.endDate)
      });
    }
    if (mode === 'create' && defaultEnvironmentTeachers) {
      setEnvironmentTeachers(defaultEnvironmentTeachers);
    } else if (!srcEnvironmentId) {
      setEnvironmentTeachers([]);
    }
  }, [mode, schoolYear?.endDate, srcEnvironmentId, defaultEnvironmentTeachers, productInfo, setEnvironmentProductInfo, setEnvironmentTeachers, setEnvironmentDates, setSrcEnvironmentId]);
  (0, _react.useEffect)(() => {
    setSrcEnvironmentId(sourceEnvironmentId);
  }, [sourceEnvironmentId, setSrcEnvironmentId]);
  (0, _react.useEffect)(() => {
    const environmentInputTitle = environmentData.Title?.trim() || '';
    let isEnvironmentInfoValid = false;
    let isDuplicatedEnvironmentTitle = false;
    if (isInCreationMode) {
      isDuplicatedEnvironmentTitle = Boolean(environmentData.Teachers.length > 0 && environmentInputTitle.length > 0 && userEnvironments?.find(env => env.Title === environmentInputTitle));
    } else if (srcEnvironmentId && !environmentData.IsArchive) {
      isDuplicatedEnvironmentTitle = Boolean(environmentData.Teachers.length > 0 && environmentInputTitle.length > 0 && userEnvironments?.find(env => env.Ids.Id !== srcEnvironmentId && env.Title === environmentInputTitle));
    }
    if (!isDuplicatedEnvironmentTitle && environmentInputTitle.length > 0 && environmentData.Teachers.length > 0 && (environmentData.Audience.Groups?.length > 0 || environmentData.Audience.SingleStudents?.length > 0)) {
      isEnvironmentInfoValid = true;
    }
    setIsSaveDisabled(!isEnvironmentInfoValid);
    setIsDuplicatedEnvTitle(isDuplicatedEnvironmentTitle);
  }, [isInCreationMode, srcEnvironmentId, environmentData, userEnvironments]);
  const environmentNamePlaceholder = getLabel('environment_name_placeholder');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-EnvironmentManagerContainer'],
    "data-testid": "environmentEditorView",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Header, {
      title: getLabel(mode === 'create' ? 'mainViewCreateTitle' : mode === 'update' ? 'mainViewUpdateTitle' : 'mainViewDuplicateTitle')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [mode !== 'create' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_EnvironmentSelection.EnvironmentSelection, {
          selectedEnvironmentId: srcEnvironmentId,
          isLearingSite: isLearingSite,
          onChange: onSourceEnvironmentChange
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-EnvironmentManager_Row'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-EnvironmentManager_Cell_Label'],
            children: mode === 'update' ? getLabel('environment_edit_name') : getLabel('environment_name')
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-EnvironmentManager_Cell_Content'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                width: `${environmentNamePlaceholder.length * 0.45}em`
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Input, {
                id: "environmentName",
                type: "text",
                view: "none",
                maxLength: environmentTitleMaxLength,
                isDisabled: environmentData.IsArchive || mode === 'update' && !environmentData.Ids.Id,
                value: environmentData.Title,
                onChange: value => {
                  setEnvironmentTitle(value);
                },
                borderRadius: {
                  borderRadius: 10
                },
                placeholder: environmentNamePlaceholder
              })
            }), isDuplicatedEnvTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-EnvironmentManager_Warning'],
              "data-testid": "environmentDuplicatedNameWarning",
              children: getLabel('environment_duplicated_name_warning').replace('{}', '')
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TeacherSelection.TeacherSelection, {
          isDisabled: environmentData.IsArchive || mode === 'update' && !environmentData.Ids.Id,
          selectedTeachers: environmentData.Teachers?.map(t => {
            return {
              value: t.UserID,
              label: t.UserName
            };
          }),
          onChange: selectedTeachers => {
            setEnvironmentTeachers(selectedTeachers?.length ? selectedTeachers.map(t => {
              return {
                UserID: t.value,
                UserName: t.label,
                ContextGroupID: ''
              };
            }) : []);
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-EnvironmentManager_AudiencePickerContainer'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-EnvironmentManager_Cell_Label'],
            children: getLabel('participants')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudiencePickerView.AudiencePickerView, {
            view: "inline"
          })]
        }), enableRangeDateSelection && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-EnvironmentManager_Row'],
          "data-testid": "environmentDates",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-EnvironmentManager_Cell_Label'],
            children: getLabel('schedule')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-EnvironmentManager_Cell_Content'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RangeDateSelection.RangeDateSelection, {
              isDisabled: environmentData.IsArchive || mode === 'update' && !environmentData.Ids.Id,
              minDate: environmentData.IsArchive ? environmentData.Dates.Start : new Date(),
              maxDate: environmentData.IsArchive ? environmentData.Dates.End : schoolYear?.endDate ? new Date(schoolYear.endDate) : undefined,
              startDate: environmentData.Dates.Start,
              endDate: environmentData.Dates.End,
              onChange: (startDate, endDate) => {
                setEnvironmentDates({
                  Start: startDate,
                  End: endDate
                });
              }
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_main.Modal.Footer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
          id: "backButton",
          view: "link",
          onClick: onBack,
          children: getLabel('back')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_main.Modal.Footer.Section, {
        children: [mode === 'update' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
          id: "deleteButton",
          view: "outlined",
          isDisabled: environmentData.Ids.Id.length <= 0,
          onClick: () => {
            setSliderView('environmentDelete');
          },
          children: getLabel('delete')
        }), isSaveErrorVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-EnvironmentManager_Error'],
          children: getLabel('environment_error')
        }), (mode !== 'update' || !environmentData.IsArchive) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Button, {
          id: "saveButton",
          view: "contained",
          isDisabled: isSaveDisabled,
          onClick: () => {
            onSave(environmentData);
            setTimeout(() => {
              setIsSaveDisabled(true);
            }, 0);
          },
          children: getLabel('save')
        })]
      })]
    })]
  });
};
exports.SliderEditorView = SliderEditorView;